export enum ReportPeriod {
    DAY = "DAY",
    WEEK = "WEEK",
    MONTH = "MONTH",
    CURRENT_QUARTER = "CURRENT_QUARTER",
    PREVIOUS_QUARTER = "PREVIOUS_QUARTER",
    CURRENT_FINANCIAL_YEAR = "CURRENT_FINANCIAL_YEAR",
    PREVIOUS_FINANCIAL_YEAR = "PREVIOUS_FINANCIAL_YEAR",
    YEAR_TO_DATE = "YEAR_TO_DATE",
    CUSTOM = "CUSTOM"
}

export const ReportPeriods = [
    ReportPeriod.DAY,
    ReportPeriod.WEEK,
    ReportPeriod.MONTH,
    ReportPeriod.CURRENT_QUARTER,
    ReportPeriod.PREVIOUS_QUARTER,
    ReportPeriod.CURRENT_FINANCIAL_YEAR,
    ReportPeriod.PREVIOUS_FINANCIAL_YEAR,
    ReportPeriod.YEAR_TO_DATE,
    ReportPeriod.CUSTOM
];